<div class="qq-complete" [appScrollIntoView]="true">
  <div class="qq-complete__header">
    <span class="h2" *ngIf="loading">Thank you for completing your quote. </span>
    <h1 *ngIf="!loading && !error">Your Quote</h1>
    <span class="h4" *ngIf="!loading && !error && thankyou" [innerHtml]="thankyou.body"></span>
  </div>

  <ion-spinner *ngIf="loading"></ion-spinner>

  <div class="qq-complete__result" *ngIf="!loading && error">
    <div [innerHtml]="error"></div>
    <div class="summary__buttons">
      <a href="javascript:void(0)" (click)="prevPage()">
        Change Quote
      </a>
    </div>
  </div>

  <div class="qq-complete__block" *ngIf="!loading && !error">
    <div class="columns">
      <div class="apg-panel qq-complete__block__quote">
        <app-questionnaire-summary *ngIf="answersObject" hideTitle="true">
          <app-summary-row label="Name">
            {{answersObject["FirstPolicyHolderFirstName"]}} {{answersObject["FirstPolicyHolderSurName"]}}
          </app-summary-row>
          <app-summary-row label="Date of Birth">
            {{answersObject["FirstPolicyHolderDOB"] | date:'dd/MM/yyy'}}
          </app-summary-row>
          <app-summary-row label="Smoker Status">
            {{answersObject["FirstPolicyHolderSmoker"] === 'YES' ? 'Smoker': 'Non Smoker'}}
          </app-summary-row>
          <app-summary-row label="Type of policy">
            {{answersObject["TypeOfPolicy_1"] === 'SINGLE' ? 'Just me': 'For you and your partner'}}
          </app-summary-row>
          <div [ngSwitch]="answersObject['FinancialAllocationType']">
            <app-summary-row [label]="sumAssuredLabel" *ngSwitchDefault>
              {{answersObject["ProtectionLevel_1"] | pounds }}
            </app-summary-row>
            <app-summary-row label="Monthly Premium" *ngSwitchCase="'Premium'">
              {{answersObject["ProtectionLevel_Premium"] | pounds }}
            </app-summary-row>
          </div>

          <ng-container *ngIf="answersObject['TypeOfPolicy_1'] === 'DUAL'">
            <app-summary-row label="Second Policy Holder">
              {{answersObject['SecondPolicyHolderFirstName']}} {{answersObject['SecondPolicyHolderSurName']}}
            </app-summary-row>
            <app-summary-row label="Second Policy Holder Date of Birth">
              {{answersObject['SecondPolicyHolderDOB']}}
            </app-summary-row>
            <app-summary-row label="Second Policy Holder Smoker Status">
              {{answersObject["SecondPolicyHolderSmoker"] === 'YES' ? 'Smoker': 'Non Smoker'}}
            </app-summary-row>
          </ng-container>

          <app-summary-row label="Term">
            {{answersObject["PolicyTerm_1"]}} years
          </app-summary-row>
        </app-questionnaire-summary>

        <div class="summary__buttons">
          <a href="javascript:void(0)" (click)="prevPage()">
            Change Quote
          </a>
        </div>

        <div>
          <label class="select-option">Please select the option that best meets your needs:</label>
        </div>

        <div class="premiums">
          <app-premium [quote]="quoteLTA" mode="lta" helpKey="QuickQuote.LTACoverBasisHelp"
                       (continue)="continue.emit(quoteLTA)">
          </app-premium>

          <app-premium [quote]="quoteDTA" mode="dta" helpKey="QuickQuote.DTACoverBasisHelp"
                       (continue)="continue.emit(quoteDTA)">
          </app-premium>
        </div>

        <app-apg-quick-quote-notes [quickQuote]="quickQuote" [policyInfo]="false" [contactUs]="false"
                                   [policyBenefits]="false">
        </app-apg-quick-quote-notes>
      </div>

      <div class="notes">
        <app-apg-quick-quote-notes [quickQuote]="quickQuote">
        </app-apg-quick-quote-notes>
      </div>

    </div>
  </div>

</div>
